import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProductsService } from '../../../services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Product } from '../../../interfaces/product';
import { ToastsManager } from 'ng2-toastr';
import { DataHelper } from '../../../helpers/data-helper';
import { LoggerService } from '../../../services/logger.service';
import { DevicesService } from '../../../services/devices.service';
import { AuthService } from '../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { DevicesClassInterface } from '../../../interfaces/device.interface';
import { UpdateOffersStatusEnum } from '../../../enums/update-offers-status.enum';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss']
})
export class ProductEditComponent implements OnInit {
  public product: Product;
  public productCategories = DataHelper.productCategories();
  public productCategoriesList = Object.keys(this.productCategories);
  public aliases = [];
  public externalProductCodes = [];
  public requiredDocuments = [];
  public deviceCodes: DevicesClassInterface[] = [];
  public devices: DevicesClassInterface[] = [];
  public metadata = {};
  public productForm: FormGroup;
  public featureToggles: any;
  public disableDevices = true;
  public updateOffersStatusEnum = UpdateOffersStatusEnum;
  public isProductLoading = false;
  public isSubmitting = false;

  private productId;

  @ViewChild('deviceInput')
  deviceInput: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProductsService,
    private devicesService: DevicesService,
    private authService: AuthService,
    private toastr: ToastsManager,
    public translate: TranslateService
  ) {
    this.productForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      code: new FormControl('', [Validators.required]),
      productCategory: new FormControl('', [Validators.required]),
      cataloguePrice: new FormControl('', [Validators.required]),
      baseCost: new FormControl('', [Validators.required]),
      rank: new FormControl('1', [Validators.required]),
      isDeprecated: new FormControl(false),
      countCompensation: new FormControl(false)
    });
  }

  ngOnInit() {
    this.featureToggles = this.authService.featureTogglesFlags;
    this.productId = this.route.snapshot.paramMap.get('id');
    if (this.productId) {
      this.isProductLoading = true;

      this.service.getProductById(this.productId).subscribe(
        product => {
          this.isProductLoading = false;

          this.productForm.patchValue({
            name: product.name,
            code: product.code,
            productCategory: product.productCategory,
            cataloguePrice: product.cataloguePrice,
            baseCost: product.baseCost,
            rank: product.rank || 1,
            isDeprecated: product.isDeprecated,
            countCompensation: product.countCompensation
          });
          this.aliases = product.aliases;
          this.externalProductCodes = product.externalProductCodes;
          this.requiredDocuments = product.requiredDocuments;
          this.deviceCodes = product.devices || [];
          this.metadata = product.metadata;
          this.product = product;
        },
        error => {
          LoggerService.log('ProductEditComponent::ngOnInit', error);
          this.toastr.error('Problem z pobraniem danych');
          this.isProductLoading = false;
        }
      );
    }
    this.devicesService.getDevices({}).subscribe(devices => {
      this.devices = devices;

      if (this.devices.length) {
        this.disableDevices = false;
      }
    });
  }

  removeDevice(id: string) {
    this.deviceCodes = this.deviceCodes.filter(d => d.id !== id);
  }

  addDevice(event: MatAutocompleteSelectedEvent): void {
    this.deviceCodes.push(event.option.value);
    this.deviceInput.nativeElement.value = '';
  }

  addTag(event: MatChipInputEvent, array): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      array.push(value.trim());
    }

    if (input) {
      input.value = '';
    }
  }

  removeTag(tag: any, array): void {
    const index = array.indexOf(tag);

    if (index >= 0) {
      array.splice(index, 1);
    }
  }

  saveProduct(productForm: FormGroup) {
    const product: Product = {
      name: productForm.value.name,
      code: productForm.value.code,
      productCategory: productForm.value.productCategory,
      cataloguePrice: parseFloat(productForm.value.cataloguePrice),
      baseCost: parseFloat(productForm.value.baseCost),
      rank: parseFloat(productForm.value.rank),
      metadata: this.metadata,
      aliases: this.aliases,
      externalProductCodes: this.externalProductCodes,
      requiredDocuments: this.requiredDocuments,
      devices: this.deviceCodes,
      updated: new Date(),
      isDeprecated: productForm.value.isDeprecated,
      countCompensation: productForm.value.countCompensation
    };

    if (this.productId) {
      this.isSubmitting = true;

      this.service.updateProduct(this.productId, product).subscribe(
        savedProduct => {
          this.isSubmitting = false;
          this.product = savedProduct;
          this.toastr.info('Zaktualizowano produkt.');
          this.router.navigate(['products']);
        },
        error => {
          LoggerService.log('ProductEditComponent::saveProduct', error);
          this.toastr.error('Problem z aktualizacją produktu');
          this.isSubmitting = false;
        }
      );
    } else {
      this.isSubmitting = true;

      this.service.createProduct(product).subscribe(
        savedProduct => {
          this.isSubmitting = false;
          this.product = savedProduct;
          this.toastr.success('Dodano nowy produkt do listy.', 'Sukces!');
          this.router.navigate(['products']);
        },
        error => {
          LoggerService.log('ProductEditComponent::saveProduct', error);
          this.toastr.error('Problem z tworzeniem produktu');
          this.isSubmitting = false;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/products/product-edit/product-edit.component.ts